import { Toggle } from '@fluentui/react';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { ADD_IDGINTEGRATION } from '../../../actions/types'
import RequiredTextField from '../../formFields/RequiredTextField'

const IdgCustomValues = ({name}) => {

    const dispatch = useDispatch()
    const idgIntegration = useSelector((state) => state.newSite.idgIntegration)
    const template = useSelector((state) => state.newSite.Template)

    const dispatchIdgIntegration = (payload) => {
        dispatch({ type: ADD_IDGINTEGRATION, payload })
    }

    const setInstanceCode = (e, value) => {
        dispatchIdgIntegration({...idgIntegration, instanceCode: value})
    }

    const setSerieNumber = (e, value) => {
        dispatchIdgIntegration({...idgIntegration, serieNumber: value})
    }

    const _onToggleChange = (e, checked) => {
        dispatchIdgIntegration({...template.config.idgIntegration, subSerieDelimiter: idgIntegration.subSerieDelimiter, useCustomValues: checked, idgValidationNeeded: !checked})
    }

    const _onInstanceCodeBlur = () => {
        dispatchIdgIntegration({...idgIntegration, idgValidationNeeded: true})
    }

    const toggle =  <Toggle 
                        label='Do you require to connect to different IDG instance?' 
                        onText='Yes'
                        offText='No'
                        defaultChecked={idgIntegration.useCustomValues}
                        onChange={_onToggleChange}
                    />

    const containerStyles = {
        marginBottom: 10,
        position: 'relative'
    }

    const controlStyles = {
        position: 'absolute',
        top: '180px',
        width: '100%'
    }

    const instanceCodeContainer =   <div style={containerStyles}>
                                        <RequiredTextField
                                            label="IDG Instance"
                                            name="IDG Instance"
                                            onChange={setInstanceCode}
                                            value={idgIntegration.instanceCode}
                                            inline
                                            width={250}
                                            hideError
                                            onBlur={_onInstanceCodeBlur}
                                        />
                                    </div>

    const serieNumberContainer =    <div style={containerStyles}>
                                        <RequiredTextField 
                                            label="IDG Serie Number"
                                            name="IDG Serie Number"
                                            onChange={setSerieNumber}
                                            value={idgIntegration.serieNumber}
                                            inline
                                            width={250}
                                            hideError
                                        />
                                    </div>

    return(
        <div style={controlStyles}>
            {toggle}
            {idgIntegration.useCustomValues && 
                <div>
                    {instanceCodeContainer}
                    {serieNumberContainer}
                </div>
            }
        </div>
    )
}

export default IdgCustomValues


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/IdgCustomValues.js